export const set_current_user_loading = () => ({
    type: "SET_CURRENT_USER_LOADING"
});

export const set_current_user = (userData) => ({
    type: "SET_CURRENT_USER",
    payload: userData
});

export const set_current_user_error = (error) => ({
    type: "SET_CURRENT_USER_ERROR",
    payload: error
});

export const clear_current_user = () => ({
    type: "CLEAR_CURRENT_USER"
});